module.exports = __webpack_public_path__ + "img/rhombus-green.2e01da90.svg";